// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-2KTv","footer-content":"footer-content-6ncx","footerContent":"footer-content-6ncx","container":"container-2wOL"};